// GENERATED by `bin/rails jynio:languages:export_signed` from config/languages.yml —
// do not edit by hand. Signed languages have no spoken form. The backend owns
// the authoritative gates (capture refusal, TTS skip — Language#signed, a
// column); this mirror only drives display: "coming soon" states on
// Flashcards/Puzzles, hiding speech UI, the hand glyph in LanguageFlag.
// spec/frontend/signed_languages_spec.rb fails when it drifts.
export const SIGNED_LANGUAGE_CODES = [
  "ads", "aed", "aen", "afg", "ajs", "ase", "asf", "asp", "asq", "bfi", "bfk", "bog",
  "bqn", "bqy", "bvl", "bzs", "cds", "csc", "csd", "cse", "csf", "csg", "csl", "csn",
  "csq", "csr", "csx", "doq", "dse", "dsl", "dsz", "ecs", "ehs", "esl", "esn", "eso",
  "eth", "fcs", "fse", "fsl", "fss", "gds", "gse", "gsg", "gsm", "gss", "gus", "hab",
  "haf", "hds", "hks", "hos", "hps", "hsh", "hsl", "icl", "iks", "ils", "inl", "ins",
  "ise", "isg", "isr", "jcs", "jhs", "jks", "jls", "jos", "jsl", "jus", "kgi", "kvk",
  "lbs", "lgs", "lls", "lsb", "lsc", "lsl", "lsn", "lso", "lsp", "lst", "lsv", "lsw",
  "lsy", "lws", "mdl", "mfs", "msd", "msr", "mzc", "mzy", "nbs", "ncs", "nsi", "nsl",
  "nsp", "nsr", "nzs", "pgz", "pks", "prl", "prz", "psc", "psg", "psl", "pso", "psp",
  "psr", "pys", "rib", "rms", "rnb", "rsl", "rsn", "sdl", "sfb", "sfs", "sgg", "sgx",
  "slf", "sls", "sqk", "sqs", "sqx", "ssp", "ssr", "svk", "swl", "syy", "szs", "tse",
  "tsm", "tsq", "tss", "tsy", "tza", "ugn", "ugy", "ukl", "uks", "vgt", "vsi", "vsl",
  "vsv", "wbs", "xki", "xml", "xms", "ysl", "ysm", "zib", "zsl",
];

const SIGNED = new Set(SIGNED_LANGUAGE_CODES);

export function isSignedLanguage(code: string | null | undefined): boolean {
  return !!code && SIGNED.has(code);
}
